import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import SearchBarWrapper from 'components/SearchBarWrapper';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import SuppliersTable, { SUPPLIER_COLUMNS, SUPPLIER_CARDS, SUPPLIER_MIN_TABLE_WIDTH } from 'components/Tables/Suppliers';
import * as DataList from 'components/DataList';
import Page from 'components/Page';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';

const PageWrapGray = styled('div')`
  padding: 5px 5px 0px 5px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'supplierStore', 'viewStore') @observer
class SuppliersIndexPage extends Component {

  @observable visible = true;

  render() {
    let content;
    let {
      supplierStore,
      viewStore,
      supplierStore: {
        suppliers: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={SUPPLIER_COLUMNS}
          cards={SUPPLIER_CARDS}
          minTableWidth={SUPPLIER_MIN_TABLE_WIDTH}
          noun="suppliers"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="suppliers" onRetry={() => supplierStore.loadSuppliers()} />;
    }
    if (!isError && !isLoading) {
      content = <SuppliersTable />
    }
    return (
      <div>
        <Helmet>
          <title>Suppliers | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
        <Sticky enabled={true} top={0} innerZ={9}>
          <SearchBarWrapper>
            <SearchBars.SupplierSearch key={viewStore.listFiltersVersion} />
          </SearchBarWrapper>
        </Sticky>
        <Page>
          <Card>
            {content}
          </Card>
        </Page>
        </PageWrapGray>
      </div>
      
    )
  }

};

export default SuppliersIndexPage;